/******************************************************************************

Copyright (c) 2020-2021, Visual Elements

******************************************************************************/

// @format

/** Everviz projects page
 *
 * List all the users projects
 *
 *
 */

import { cr, ap, on, setStyle } from './../core/highed.dom';
import Pagination from './highed.everviz.pagination';
import Events from './../core/highed.events';

export default function(parent) {
  const container = cr('div', 'everviz-cms-project-container'),
        searchProjectsContainer = cr('div', 'everviz-search-projects-container'),
        evervizFilterContainer = cr('div', "everviz-filter-container"),
        evervizFilterInputsContainer = cr('div', "everviz-input-container"),
        evervizFilterInput = cr('input', "everviz-input"),
        evervizFilterInputIcon = cr('i', "fa fa-search everviz-search-icon"),
        evervizFilterCancelIcon = cr('i', "fa fa-times everviz-cancel-icon"),
        evervizCreateNewButton = cr('button', "everviz-button", "Create New"),
        evervizInsertButton = cr('button', "everviz-button grey", "Insert"),
        evervizProjectsListContainer = cr('div', "everviz-cms-chart-container"),
        evervizProjectsContainer = cr('div', "everviz-cms-chart-container"),
        evervizPaginationContainer = cr('div', "everviz-pagination-container"),/*
        evervizPaginationBackButton = cr('button', "everviz-button circle back red", "<i class='fa fa-chevron-left'/>"),
        evervizPaginationNextButton = cr('button', "everviz-button circle red", "<i class='fa fa-chevron-right'/>"),*/
        evervizNoProjectContainer = cr('div', "everviz-no-projects"),
        evervizNoProjectsWarningContainer = cr('div', "no-chart-warning-container", "<div class='fa fa-bar-chart'></div><div><h2>No projects</h2></div>"),
        evervizSpinner = cr('div', "everviz-linking-spinner old", '<i class="fa fa-spinner fa-spin"/>'),
        events = Events();
    let pagination = Pagination(evervizPaginationContainer);

        
  evervizFilterInput.placeholder = "Search for project";
  
  hideCancelIcon();

  let pageSize = 15,
      page = 1,
      projects = [],
      selectedProject = false,
      pageCount = false,
      fn = false,
      searchTimeout = false;

  let modalBody = parent;

  function attachEvents(){

    on(evervizFilterCancelIcon, 'click', () => {
      evervizFilterInput.value = '';
      pagination.setPage(1);
     // page = 1;
			getProjects(pagination.getPage(), '');
    })

    on(evervizInsertButton, 'click', () => {
      if (!selectedProject) return;
      if (fn) {
        fn(selectedProject);
      }

      toggleInsertButton();
    })

    on(evervizCreateNewButton, 'click', () => {
      let win = window.open('https://app.everviz.com/new?cms=wp_classic', '_blank');
      win.focus();
    })

    on(evervizFilterInput, 'keyup', (e) => {
      if (evervizFilterInput.value === '') hideCancelIcon();
      else showCancelIcon();

      if (searchTimeout) clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        //Run search
        pagination.setPage(1);
      //  page = 1
        show(modalBody, true, true);
        clearTimeout(searchTimeout);
      }, 500);
    });

    pagination.on('ChangePage', (index) => {
      getProjects(index, evervizFilterInput.value);
    });
  }

  function toggleElements(evervizProjectsListContainerProp, evervizSpinnerProp, evervizPaginationContainerProp){    
    setStyle(evervizProjectsListContainer, {
      display: evervizProjectsListContainerProp
    });
    setStyle(evervizSpinner, {
      display: evervizSpinnerProp
    });
    setStyle(evervizPaginationContainer, {
      display: evervizPaginationContainerProp
    });
  }

  function toggleInsertButton(active) {
    if (active) {
      evervizInsertButton.classList.remove('grey');
      evervizInsertButton.classList.remove('red');
      evervizInsertButton.className += ' red';
    } else {
      evervizInsertButton.classList.remove('red');
      evervizInsertButton.classList.remove('grey');
      evervizInsertButton.className += ' grey';
      if (selectedProject && selectedProject.element && selectedProject.element.classList) {
        selectedProject.element.classList.remove('active');
      }
      selectedProject = false;
    }
  }

  function setCallback(cb){
    fn = cb;
  }

	function getProjects(page=1, searchValue, pageSize=15){
		highed.api.getCharts(page, pageSize, searchValue)
		.then(charts => {
      toggleInsertButton();
      projects = charts.data;
      pagination.rebuild(charts.pageCount);
      show(modalBody, false);
		});
	}

  function rebuildProjectList() {
    evervizProjectsContainer.innerHTML = '';
    if (projects.length === 0) {
      //No projects. show no projects message
      ap(evervizProjectsContainer, evervizNoProjectContainer);
      setStyle(evervizPaginationContainer, {
        display: 'none'
      })
      return;
    } else {
      setStyle(evervizPaginationContainer, {
        display: 'block'
      })
    }

    projects.forEach((project, index) => {

      const evervizChartContainer = cr('div', "everviz-chart-container "),
            evervizChartImageContainer = cr('div', "chart-image"),
            evervizChartImage = cr('img', 'img'),
            evervizChartTitle = cr('div', "chart-title ", project.name);
      
      on(evervizChartContainer, 'click', () => {

        if (selectedProject) {
          selectedProject.element.classList.remove('active');
        }
        evervizChartContainer.className += ' active';
        toggleInsertButton(true);
        
        selectedProject = {
          element: evervizChartContainer,
          index: index,
          props: project
        }
      });
      evervizChartImage.src=project.thumbnail_url;

      ap(evervizChartContainer, ap(evervizChartImageContainer, evervizChartImage), evervizChartTitle);
      ap(evervizProjectsContainer, evervizChartContainer);
    })
  }

  function show(parent = modalBody, loading=false, refreshProjects) {
    
    if (loading) {
      toggleElements('none', 'block', 'none');
    } else {
      toggleElements('block', 'none', 'block');
      rebuildProjectList();
    }

    ap(parent, container);
    modalBody = parent;

    if (evervizFilterInput.value === '') hideCancelIcon()
    else showCancelIcon();
    if (refreshProjects) getProjects(pagination.getPage(), evervizFilterInput.value);
  }

  function hideCancelIcon(){
    setStyle(evervizFilterCancelIcon, {
      display: 'none'
    });
  }

  function showCancelIcon(){
    setStyle(evervizFilterCancelIcon, {
      display: 'block'
    });
  }

  attachEvents()

  ap(evervizNoProjectContainer,evervizNoProjectsWarningContainer);
  ap(evervizFilterInputsContainer, evervizFilterInput, evervizFilterInputIcon, evervizFilterCancelIcon);
  ap(evervizFilterContainer, evervizFilterInputsContainer, evervizCreateNewButton, evervizInsertButton);
  ap(evervizProjectsListContainer, evervizProjectsContainer);
  //ap(evervizPaginationContainer, evervizPaginationBackButton, evervizPaginationNextButton);
  ap(searchProjectsContainer, evervizFilterContainer, evervizSpinner, evervizProjectsListContainer, evervizPaginationContainer);
  ap(container, searchProjectsContainer);

  ///////////////////////////////////////////////////////////////////////////

  return {
    //editor: editor,
    show,
    on: events.on,
    getProjects,
    setCallback
  };
};
